export const UI = {
  en: {
    nav: {
      about: "About",
      companies: "Companies",
      contact: "Contact",
      cta: "Get in Touch",
      langToggle: "عربي",
      location: "Muscat, Sultanate of Oman",
    },
    hero: {
      city: "Muscat — Sultanate of Oman",
      line1: "Earn trust.",
      line2: "Then grow.",
      sub: "Altalib Group is a Muscat-based group of companies built on a simple idea: earn trust, then grow into new industries without losing it.",
      ctaPrimary: "Explore the Group",
      ctaSecondary: "Get in Touch",
      foot: "Est. 2011 — Seven Companies, One Group",
      scroll: "Scroll",
    },
    stats: {
      eyebrow: "The numbers speak for themselves",
      items: [
        { id: "founded", from: 1980, to: 2011, decimals: 0, suffix: "", caption: "Founded in Muscat" },
        { id: "companies", from: 0, to: 7, decimals: 0, suffix: "", caption: "Companies operating individually under one trusted name" },
        { id: "vision", text: "Vision 2040", caption: "Growing alongside Oman's national vision." },
      ],
    },
    about: {
      eyebrow: "About Altalib Group",
      headingA: "A simple idea,",
      accent: "grown",
      headingB: "into a group.",
      side: "From one used-car showroom in Muscat to seven brands across six industries — this is how Altalib Group thinks about growth.",
    },
    companies: {
      eyebrow: "Our Companies",
      headingA: "Seven brands.",
      accent: "One standard.",
      sub: "Each company operates independently, yet shares the same commitment to transparency, quality, and long-term relationships.",
      discover: "Discover",
      enquirePrefix: "Enquire about",
    },
    brokerage: {
      eyebrow: "Commercial Brokerage & Business Development",
      headingA: "Connecting opportunities.",
      accent: "Building trusted partnerships.",
      side: "Beyond our seven brands, the group works directly with partners at home and abroad to move trade, investment, and new ventures forward.",
      items: [
        { title: "Commercial Brokerage", desc: "Connecting qualified buyers, sellers, investors and strategic partners." },
        { title: "International Business Opportunities", desc: "Facilitating cross-border trade and global market access." },
        { title: "Business Development", desc: "Identifying and developing new business opportunities across key sectors." },
        { title: "Strategic Partnerships", desc: "Building long-term relationships with local and international partners." },
        { title: "Market Entry Support", desc: "Supporting companies to enter and expand in Oman and the GCC." },
        { title: "Deal Facilitation", desc: "Assisting with commercial coordination and negotiations." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      headingA: "Let's start a",
      accent: "conversation.",
      sub: "Whether it's a car, a delivery, an investment, or a digital product — tell us what you're looking for and the right team will reach out.",
      info: [
        { label: "Phone", value: "+968 2413 8830" },
        { label: "Email", value: "info@altalibgroup.com" },
        { label: "Head Office", value: "Al Udhaybah, Muscat, Sultanate of Oman" },
      ],
      labels: { name: "Full Name", email: "Email", company: "Company / Interest", message: "Message" },
      placeholders: { name: "Your name", email: "you@example.com", message: "How can we help?" },
      send: "Send Message",
      sending: "Sending…",
      success: "Message sent. The Altalib Group team will be in touch soon.",
      error: "Something went wrong sending your message. Please try again.",
      general: "General Inquiry",
    },
    footer: {
      tagline: "Earn trust, then grow into new industries without losing it.",
      location: "Muscat — Sultanate of Oman",
      companiesHeading: "Companies",
      groupHeading: "Group",
      about: "About Altalib Group",
      ourCompanies: "Our Companies",
      contact: "Contact",
      rights: "© 2026 Altalib Group. All rights reserved.",
      mark: "مجموعة آل طالب — ALTALIB GROUP",
    },
  },
  ar: {
    nav: {
      about: "عن المجموعة",
      companies: "شركاتنا",
      contact: "تواصل معنا",
      cta: "تواصل معنا",
      langToggle: "EN",
      location: "مسقط، سلطنة عُمان",
    },
    hero: {
      city: "مسقط — سلطنة عُمان",
      line1: "اكسب الثقة.",
      line2: "ثم انمُ.",
      sub: "مجموعة آل طالب هي مجموعة شركات مقرها مسقط، بُنيت على فكرة بسيطة: اكسب الثقة أولاً، ثم توسّع في قطاعات جديدة دون أن تفقدها.",
      ctaPrimary: "استكشف المجموعة",
      ctaSecondary: "تواصل معنا",
      foot: "تأسست 2011 — سبع شركات، مجموعة واحدة",
      scroll: "مرّر للأسفل",
    },
    stats: {
      eyebrow: "الأرقام تتحدث عن نفسها",
      items: [
        { id: "founded", from: 1980, to: 2011, decimals: 0, suffix: "", caption: "تأسست في مسقط" },
        { id: "companies", from: 0, to: 7, decimals: 0, suffix: "", caption: "شركات تعمل باستقلالية تحت اسمٍ واحد موثوق" },
        { id: "vision", text: "رؤية 2040", caption: "ننمو جنباً إلى جنب مع رؤية عُمان الوطنية." },
      ],
    },
    about: {
      eyebrow: "عن مجموعة آل طالب",
      headingA: "فكرة بسيطة،",
      accent: "نمت",
      headingB: "لتصبح مجموعة.",
      side: "من معرض واحد للسيارات المستعملة في مسقط إلى سبع علامات في ستة قطاعات — هكذا تفكر مجموعة آل طالب في النمو.",
    },
    companies: {
      eyebrow: "شركاتنا",
      headingA: "سبع علامات.",
      accent: "معيار واحد.",
      sub: "تعمل كل شركة باستقلالية، وتتشارك جميعها الالتزام ذاته بالشفافية والجودة والعلاقات طويلة الأمد.",
      discover: "اكتشف",
      enquirePrefix: "استفسر عن",
    },
    brokerage: {
      eyebrow: "الوساطة التجارية وتطوير الأعمال",
      headingA: "نربط الفرص.",
      accent: "نبني شراكات موثوقة.",
      side: "إلى جانب علاماتنا السبع، تعمل المجموعة مباشرة مع شركاء في الداخل والخارج لدفع عجلة التجارة والاستثمار والمشاريع الجديدة.",
      items: [
        { title: "الوساطة التجارية", desc: "ربط المشترين والبائعين والمستثمرين والشركاء الاستراتيجيين المؤهلين." },
        { title: "الفرص التجارية الدولية", desc: "تيسير التجارة عبر الحدود والوصول إلى الأسواق العالمية." },
        { title: "تطوير الأعمال", desc: "تحديد وتطوير فرص أعمال جديدة عبر القطاعات الرئيسية." },
        { title: "الشراكات الاستراتيجية", desc: "بناء علاقات طويلة الأمد مع شركاء محليين ودوليين." },
        { title: "دعم دخول الأسواق", desc: "دعم الشركات للدخول والتوسع في عُمان ودول مجلس التعاون الخليجي." },
        { title: "تيسير الصفقات", desc: "المساعدة في التنسيق التجاري والمفاوضات." },
      ],
    },
    contact: {
      eyebrow: "تواصل معنا",
      headingA: "لنبدأ",
      accent: "الحوار.",
      sub: "سواء كان الأمر سيارة، أو عملية توصيل، أو استثماراً، أو منتجاً رقمياً — أخبرنا بما تبحث عنه وسيتواصل معك الفريق المناسب.",
      info: [
        { label: "الهاتف", value: "+968 2413 8830" },
        { label: "البريد الإلكتروني", value: "info@altalibgroup.com" },
        { label: "المقر الرئيسي", value: "الأذيبة، مسقط، سلطنة عُمان" },
      ],
      labels: { name: "الاسم الكامل", email: "البريد الإلكتروني", company: "الشركة / مجال الاهتمام", message: "الرسالة" },
      placeholders: { name: "اسمك", email: "you@example.com", message: "كيف يمكننا مساعدتك؟" },
      send: "إرسال الرسالة",
      sending: "جارٍ الإرسال…",
      success: "تم إرسال رسالتك. سيتواصل معك فريق مجموعة آل طالب قريباً.",
      error: "حدث خطأ أثناء إرسال رسالتك. يرجى المحاولة مرة أخرى.",
      general: "استفسار عام",
    },
    footer: {
      tagline: "اكسب الثقة، ثم توسّع في قطاعات جديدة دون أن تفقدها.",
      location: "مسقط — سلطنة عُمان",
      companiesHeading: "الشركات",
      groupHeading: "المجموعة",
      about: "عن مجموعة آل طالب",
      ourCompanies: "شركاتنا",
      contact: "تواصل معنا",
      rights: "© 2026 مجموعة آل طالب. جميع الحقوق محفوظة.",
      mark: "مجموعة آل طالب — ALTALIB GROUP",
    },
  },
};

export const ABOUT_CHAPTERS_AR = [
  {
    num: "01",
    title: "اكسب الثقة، ثم انمُ",
    body: "مجموعة آل طالب هي مجموعة شركات مقرها مسقط، بُنيت على فكرة بسيطة: اكسب الثقة أولاً، ثم توسّع في قطاعات جديدة دون أن تفقدها. وما بدأ بدخول فورمولاموتور إلى سوق السيارات المستعملة في عُمان عام 2011، قد نما ليصبح محفظة أعمال تشمل بيع السيارات والعناية بها، وتأجير السيارات الفاخرة، وخدمات التوصيل والخدمات اللوجستية المتعددة، والاستثمار العقاري، والتجارة الإلكترونية، والتكنولوجيا.",
  },
  {
    num: "02",
    title: "سبع علامات، التزام واحد",
    body: "كل علامة تحمل اسم آل طالب — فورمولاموتور، وكلير برو، وإيليت لتأجير السيارات، وتوصل أوصل، وآل طالب للاستثمار، وطالبكس، وشريكتنا التقنية وفا سوليوشنز — تعمل باستقلالية، وإن كانت جميعها تشترك في الالتزام ذاته بالشفافية والجودة والعلاقات طويلة الأمد مع الأشخاص الذين نخدمهم.",
  },
  {
    num: "03",
    title: "نتنوّع مع عُمان",
    body: "ومع تنويع اقتصاد عُمان مصادره في ظل رؤية 2040، تتنوع مجموعة آل طالب معه، لتبني أعمالاً تخلق قيمة حقيقية للعملاء والشركاء والمستثمرين على حد سواء.",
  },
];

export const COMPANY_COPY_AR = {
  formulamotor: {
    name: "فورمولاموتور",
    tagline: "بيع السيارات",
    est: "تأسست 2011",
    card: "الشركة المؤسسة لمجموعة آل طالب — اسم موثوق ومحترم في سوق السيارات العُماني منذ عام 2011، بتقييم 4.1/5 على جوجل.",
    paragraphs: [
      "فورمولاموتور هي الشركة المؤسسة لمجموعة آل طالب، تأسست عام 2011 برؤية واضحة: بناء اسم موثوق ومحترم في سوق السيارات العُماني. وعلى مدى أكثر من 15 عاماً، بنينا خبرة عميقة في بيع وشراء السيارات المستعملة عالية الجودة، وبنينا بالقدر ذاته علاقات دائمة مع العملاء الذين يأتمنوننا على واحدة من أكبر مشترياتهم.",
      "نخدم جميع شرائح المجتمع العُماني، ونوفر تشكيلة واسعة من السيارات بقيمة تنافسية، مدعومة بخدمة مصممة لتناسب احتياجات كل عميل. فالشفافية والموثوقية ورضا العملاء تقع في صميم كل ما نقوم به — وينعكس ذلك في سمعتنا القوية وتقييمنا البالغ 4.1/5 على جوجل.",
      "في فورمولاموتور، بيع السيارة ليس مجرد صفقة، بل بداية علاقة مبنية على الثقة. وبفريق متفانٍ ومعرفة عميقة بالسوق وشغف حقيقي بالتميز، نواصل النمو والمساهمة في قطاعي السيارات والعقارات في عُمان، واضعين معايير أعلى للجودة والخدمة وتجربة العملاء في كل خطوة.",
    ],
    lists: [
      {
        title: "لماذا تختار فورمولاموتور:",
        items: [
          "أكثر من 15 عاماً من الخبرة الموثوقة في سوق السيارات العُماني",
          "تشكيلة واسعة من السيارات المستعملة عالية الجودة تناسب كل ميزانية واحتياج",
          "أسعار شفافة وخدمة مهنية صادقة",
          "تقييم 4.1/5 على جوجل بُني على علاقات حقيقية مع العملاء",
          "جزء من مجموعة آل طالب، واحدة من أعرق المجموعات الخاصة في عُمان",
        ],
      },
    ],
    imageAlt: "سيارة عالية الأداء تمثل مبيعات السيارات في فورمولاموتور",
  },
  clearpro: {
    name: "كلير برو",
    tagline: "العناية بالسيارات",
    est: "تأسست 2025",
    card: "علامة دولية للعناية بالسيارات — أفلام نوافذ فاخرة، وأفلام حماية الطلاء (PPF)، والتلميع الاحترافي، والعناية الشاملة بأسطح المركبات.",
    paragraphs: [
      "في عام 2025، قدّمت مجموعة آل طالب علامة كلير برو إلى السوق العُماني — علامة دولية للعناية بالسيارات صُممت لحماية كل مركبة تلمسها وتعزيز جمالها. ومن خلال كلير برو، نقدم مجموعة كاملة من خدمات العناية بالسيارات، من أفلام النوافذ الفاخرة وأفلام حماية الطلاء (PPF) إلى التلميع الاحترافي والعناية الشاملة بأسطح المركبات.",
      "هدفنا بسيط: خدمة العملاء من جميع شرائح المجتمع من خلال الجمع بين المنتجات المتقدمة والخبرة المهنية والاهتمام الصادق بالتفاصيل. وقد بُنيت كلير برو على الجودة والموثوقية والابتكار ورضا العملاء — وهي ذات القيم التي جعلت من مجموعة آل طالب اسماً يثق به العُمانيون.",
      "وبدعم من قوة مجموعة آل طالب وخبرتها، تواصل كلير برو نموها في مختلف أنحاء عُمان، بهدف وضع معايير جديدة في حماية السيارات والعناية بها لعملاء يريدون لمركباتهم أن تبدو — وتبقى — في أفضل حال.",
    ],
    lists: [
      {
        title: "ما نقدمه:",
        items: [
          "أفلام نوافذ فاخرة للراحة والخصوصية والحماية من الأشعة فوق البنفسجية",
          "أفلام حماية الطلاء (PPF) لحماية طلاء مركبتك",
          "تلميع احترافي وتصحيح الطلاء",
          "عناية شاملة بأسطح المركبات وتنظيفها التفصيلي",
        ],
      },
    ],
    imageAlt: "عناية احترافية بالسيارات تمثل كلير برو",
  },
  "elite-rent-a-car": {
    name: "إيليت لتأجير السيارات",
    tagline: "تأجير السيارات الفاخرة",
    est: "تنقّل فاخر",
    card: "علامة مجموعة آل طالب المتخصصة في تأجير السيارات الفاخرة — تنقّل راقٍ بلا عناء في جميع أنحاء عُمان.",
    paragraphs: [
      "إيليت لتأجير السيارات هي علامة مجموعة آل طالب المتخصصة في تأجير السيارات الفاخرة، بُنيت حول هدف واحد: جعل التنقل الفاخر أمراً سهلاً في جميع أنحاء عُمان. سواء كانت رحلة عمل، أو مناسبة خاصة، أو إجازة عائلية، أو مجرد رغبة في قيادة سيارة استثنائية، تضع إيليت لتأجير السيارات تشكيلة منتقاة من المركبات الفاخرة في متناول يدك.",
      "لقد بنينا إيليت لتأجير السيارات على الراحة والجودة والموثوقية وخدمة الضيافة الصادقة — وهي ذات القيم التي تعرّف كل أعمال عائلة مجموعة آل طالب. ومنذ لحظة استفسارك وحتى لحظة إعادة المفاتيح، هدفنا أن تكون تجربة التأجير بفخامة السيارات ذاتها.",
      "طموحنا واضح: أن نصبح الاسم الموثوق في سوق تأجير السيارات الفاخرة في عُمان، معروفين بأسلوبنا في التعامل مع عملائنا بقدر ما نُعرف به بالسيارات التي نوفرها لهم.",
    ],
    lists: [
      {
        title: "من نخدم:",
        items: [
          "المسافرون في رحلات العمل الذين يتوقعون الراحة والموثوقية في كل رحلة",
          "الزوار والسياح الذين يستكشفون عُمان بأناقة",
          "حفلات الزفاف والفعاليات والمناسبات الخاصة التي تستدعي شيئاً استثنائياً",
          "كل من يريد تجربة قيادة فاخرة متى ما احتاج إليها",
        ],
      },
      {
        title: "ما يميزنا:",
        items: [
          "أسطول فاخر منتقى بعناية ومصان بأعلى المعايير",
          "شروط تأجير مرنة للرحلات القصيرة والإقامات الطويلة",
          "تجربة حجز وتسليم سلسة",
          "دعم وموثوقية مجموعة آل طالب",
        ],
      },
    ],
    imageAlt: "سيارة رياضية فاخرة تمثل إيليت لتأجير السيارات",
  },
  "twasal-awasal": {
    name: "توصل أوصل",
    tagline: "التوصيل والخدمات اللوجستية",
    est: "التطبيق قريباً",
    card: "خدمات توصيل ولوجستيات متعددة — تتبع فوري، وتطبيق توصيل سيُطلق قريباً، وحلول توصيل بعلامتك التجارية للشركات.",
    paragraphs: [
      "توصل أوصل هي علامة مجموعة آل طالب لخدمات التوصيل والخدمات اللوجستية المتعددة، وتديرها شركة الأولى لخدمات الشحن (AlAwal Cargo Services)، شركة التوصيل العُمانية المرخصة ضمن عائلة مجموعة آل طالب. وتجتمع تقنية مجموعة آل طالب مع الخبرة التشغيلية لشركة الأولى لخدمات الشحن في منصة واحدة، بُنيت لنقل البضائع وتنمية الأعمال في جميع أنحاء عُمان.",
      "بالنسبة للعملاء الأفراد، تعني توصل أوصل توصيلاً سريعاً وموثوقاً يمكنك تتبعه من الاستلام حتى التسليم — سواء كان طرداً أو مستنداً أو احتياجاً يومياً. وسيضع تطبيق التوصيل القادم كل هذا بين يديك: احجز عملية توصيل في ثوانٍ، وتابع السائق لحظة بلحظة، وادفع بثقة، كل ذلك من تطبيق واحد. سينطلق قريباً، وقد صُمم ليجعل إرسال الأشياء واستلامها في جميع أنحاء عُمان أبسط من أي وقت مضى.",
      "أما بالنسبة للشركات، فتوصل أوصل شريك لوجستي وليس مجرد شركة توصيل. فمنصة الشحن للشركات (B2B) تمنح الشركات تجربة توصيل بعلامتها التجارية الخاصة — من التسعير المخصص وإصدار بوالص الشحن إلى واجهة برمجية جاهزة للمطورين (API) للشركات التي ترغب في ربط أنظمتها مباشرة. ومهما كان حجم أعمالك، صُممت توصل أوصل لتبقي البضائع في حركة دائمة والعملاء على اطلاع في كل خطوة.",
    ],
    lists: [
      {
        title: "لماذا تختار الشركات والعملاء توصل أوصل:",
        items: [
          "تتبع فوري من الاستلام حتى التسليم",
          "تطبيق توصيل مخصص سيُطلق قريباً للحجوزات السريعة عند الطلب",
          "حلول توصيل بعلامتك التجارية للشركات بمختلف أحجامها",
          "بدعم من شركة الأولى لخدمات الشحن، شركة التوصيل المرخصة لمجموعة آل طالب",
          "تغطية متنامية عبر المدن الرئيسية في عُمان",
        ],
      },
    ],
    imageAlt: "مستودع لوجستي يمثل شبكة التوصيل في توصل أوصل",
  },
  "altalib-investments": {
    name: "آل طالب للاستثمار",
    tagline: "الاستثمار العقاري",
    est: "بما يتوافق مع رؤية 2040",
    card: "الذراع الاستثمارية العقارية للمجموعة — تربط رأس المال بالفرص في واحدة من أكثر أسواق العقارات الواعدة في المنطقة.",
    paragraphs: [
      "آل طالب للاستثمار هي الذراع الاستثمارية العقارية لمجموعة آل طالب، بُنيت لربط رأس المال بالفرص في واحدة من أكثر أسواق العقارات الواعدة في المنطقة. نحدد المشاريع العقارية عالية الإمكانات في مختلف أنحاء عُمان — من التطويرات السكنية الراقية في مناطق مثل الموج وتلال مسقط ومسقط باي إلى الفرص الناشئة المتوافقة مع أجندة النمو الوطنية رؤية 2040 — ونستثمر فيها مباشرة لتحقيق عوائد قوية ومستدامة.",
      "كما نعمل مع مستثمرين يشاركوننا قناعتنا بمستقبل عُمان. فإذا كنت تبحث عن بديل لصناديق الاستثمار المشتركة أو الودائع الثابتة أو السندات الحكومية، تعمل آل طالب للاستثمار كشريك ومستشار موثوق لك: نحدد المشروع المناسب، ونهيكل الاستثمار، ونديره نيابة عنك، لتستفيد من نمو سوق العقارات العُماني دون أن تديره بنفسك.",
      "يقوم نهجنا على ذات القيم التي تعرّف مجموعة آل طالب ككل — الشفافية والاجتهاد والنظرة طويلة الأمد. فنحن لا نكتفي بإيجاد الفرص، بل نعتني بها وبالمستثمرين الذين يدعمونها.",
    ],
    lists: [
      {
        title: "ما نقدمه للمستثمرين:",
        items: [
          "فرص عقارية منتقاة بعناية في أرقى المواقع في عُمان",
          "هيكلة الاستثمارات وإدارة المحافظ بالكامل",
          "نهج شراكة طويل الأمد، متوافق مع رؤية عُمان 2040",
          "دعم وسجل حافل من مجموعة آل طالب",
        ],
      },
    ],
    imageAlt: "عمارة عصرية للشركات تمثل آل طالب للاستثمار",
  },
  "wafa-solutions": {
    name: "وفا سوليوشنز",
    tagline: "التقنية والحلول الرقمية",
    est: "عُمان · الهند · الولايات المتحدة",
    card: "الشريك التقني الذي يقف خلف منصات المجموعة — برمجيات مخصصة، وحلول SaaS، وتحول رقمي.",
    paragraphs: [
      "وفا سوليوشنز هي الشريك التقني لمجموعة آل طالب — الفريق الذي يقف خلف البرمجيات التي تشغّل منصات المجموعة نفسها، وبشكل متزايد التحول الرقمي للشركات في جميع أنحاء عُمان. وقد بُنيت وفا سوليوشنز لحل مشكلة حقيقية: احتاجت مجموعة آل طالب تقنية مخصصة وقوية لتشغيل توصل أوصل وطالبكس، فبدلاً من الاستعانة بمصادر خارجية، بنت المجموعة هذه القدرة داخلياً.",
      "واليوم، تعد وفا سوليوشنز شركة عُمانية للتقنية والمنتجات الرقمية مع حضور متنامٍ في الهند والولايات المتحدة، وتقدم تصميم المواقع المخصصة، وتطوير حلول SaaS القابلة للتوسع، وبرمجيات المؤسسات، وأنظمة إدارة علاقات العملاء (CRM) وتخطيط موارد المؤسسات (ERP)، ومنصات إدارة الموارد البشرية (HRMS)، وتطبيقات الهواتف، وخدمات العلامات التجارية والتسويق ودعم التطبيقات المتكاملة. إنها ذات الخبرة التقنية التي بنت منصة توصيل توصل أوصل وسوق طالبكس الإلكتروني، وهي متاحة الآن للشركات الأخرى التي تريد التحرك أسرع بتقنية مبنية بالطريقة الصحيحة.",
      "كما تقدم وفا سوليوشنز تركيزاً قوياً على الحوكمة والمخاطر والامتثال في السوق، لمساعدة المؤسسات على بناء الأسس الرقمية التي تحتاجها للنمو بأمان وثقة — وهي قدرة تزداد أهمية كلما انتقل المزيد من اقتصاد عُمان إلى الفضاء الرقمي.",
    ],
    lists: [
      {
        title: "ما تقدمه وفا سوليوشنز:",
        items: [
          "برمجيات مخصصة ومنصات SaaS وتطبيقات هواتف مبنية من البداية للنهاية",
          "أنظمة CRM وERP وHRMS مصممة لطبيعة عمل الشركات الفعلية",
          "دعم العلامات التجارية والتصميم والتسويق الرقمي",
          "دعم وصيانة مستمرة للتطبيقات",
          "سجل حافل مثبت، بُني على منصات حقيقية لمجموعة آل طالب",
        ],
      },
    ],
    imageAlt: "بيئة عمل تقنية تمثل وفا سوليوشنز",
  },
  talibx: {
    name: "طالبكس",
    tagline: "سوق التجارة الإلكترونية",
    est: "أحدث مشاريع المجموعة",
    card: "سوق إلكتروني يجلب التسوق الإلكتروني الموثوق بأسعار مناسبة إلى عُمان — ومع الوقت، إلى منطقة الخليج ككل.",
    paragraphs: [
      "طالبكس هو أحدث مشاريع مجموعة آل طالب: سوق للتجارة الإلكترونية بُني ليجلب التسوق الإلكتروني الموثوق وبأسعار مناسبة إلى عُمان، ومع الوقت إلى منطقة الخليج ككل. وطالبكس مشروع مشترك بين وفا سوليوشنز التي توفر التقنية، وتوصل أوصل التي توفر شبكة التوصيل — أي أن طالبكس ليس مجرد متجر إلكتروني آخر، بل سوق مدعوم ببنية تحتية قادرة فعلاً على إيصال المنتجات إلى أبواب العملاء بسرعة وموثوقية.",
      "وقد صُمم طالبكس بمقياس وإتاحة أكبر أسواق المنطقة الإلكترونية في الحسبان، ليمنح العملاء تشكيلة ضخمة من المنتجات بأسعار تنافسية حقيقية، وكل ذلك عبر تجربة تسوق بسيطة وعصرية. أما البائعون والشركاء، فيوفر لهم طالبكس منصة للوصول إلى العملاء في جميع أنحاء عُمان مع دعم لوجستي يسندها.",
      "ومع نمو طالبكس، يمتد طموحنا إلى ما هو أبعد من عُمان — لبناء سوق قادر على التوسع عبر دول مجلس التعاون الخليجي، مدعوماً بذات القيم التي تحرك كل أعمال مجموعة آل طالب: الثقة والجودة والالتزام الصادق بتجربة العميل.",
    ],
    lists: [
      {
        title: "ما الذي يميز طالبكس:",
        items: [
          "مدعوم بشركتي المجموعة للتقنية والخدمات اللوجستية",
          "تشكيلة واسعة ومتنامية من المنتجات بأسعار تنافسية",
          "توصيل عبر شبكة توصل أوصل اللوجستية الخاصة",
          "بُني لعُمان، وطموحه يمتد عبر دول الخليج",
        ],
      },
    ],
    imageAlt: "مساحة تجزئة عصرية تمثل سوق طالبكس الإلكتروني",
  },
};
